function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button } from 'reactstrap';
import { getValue, appendPath, parentPath } from '@truqc/content-path';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import React from 'react';
import { kebabCase } from 'lodash';
import { enabledSelector, newPathSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import logValueOnChange from '../commonActions/logValueOnChange';
import { getContent } from '../selectors/simpleSelectors';
const DuplicateButton = ({
  content,
  duplicateContentPaths: _duplicateContentPaths = [],
  enabled,
  onChange,
  path,
  title
}) => {
  const handleDuplicate = () => {
    const contentSrc = getValue(path, content);
    let newContent = {};
    if (_duplicateContentPaths && _duplicateContentPaths.length) {
      _duplicateContentPaths.forEach(dupPath => {
        newContent[dupPath] = contentSrc[dupPath];
      });
    } else {
      newContent = _objectSpread({}, contentSrc);
    }
    // eslint-disable-next-line no-underscore-dangle
    newContent._created = moment().toISOString();
    const newPath = appendPath(parentPath(path), uuidV4().toUpperCase());
    onChange({
      path: newPath,
      value: newContent
    });
  };
  return /*#__PURE__*/React.createElement(Button, {
    disabled: !enabled,
    block: true,
    onClick: handleDuplicate,
    className: `t-rb-duplicate-button t-db-${kebabCase(title)}`
  }, title);
};
DuplicateButton.propTypes = {
  content: PropTypes.shape({}).isRequired,
  duplicateContentPaths: PropTypes.arrayOf(PropTypes.string),
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export { DuplicateButton as UncomposedDuplicateButton };
export default entityComposition(DuplicateButton, [], {
  enabled: enabledSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  content: getContent
});